import { supabase } from './supabase';
import { MISSING_SORT_ORDER_MESSAGE, isMissingSortOrderColumn } from './sortOrder';

// Write the given order to `table`: each id gets its index as sort_order.
// Pass reset: true to clear the custom order (sort_order = null) for those ids instead.
export const saveSortOrder = async (table, ids, { reset = false } = {}) => {
  const results = await Promise.all(
    ids.map((id, index) => supabase.from(table).update({ sort_order: reset ? null : index }).eq('id', id))
  );
  const failed = results.find((result) => result.error);
  if (failed) {
    if (isMissingSortOrderColumn(failed.error)) throw new Error(MISSING_SORT_ORDER_MESSAGE);
    throw failed.error;
  }
};
